module.exports = __webpack_public_path__ + "media/images/favicon-e9f245e415560d654ab1543cc04e3cdd.ico";